// =========================================
// Shared Swiper core
// Bundled ONCE and enqueued only on pages that contain a slider block
// (see inc/acf-blocks.php). Per-block scripts read Swiper + the modules they
// need from these globals instead of each bundling their own copy.
// =========================================
import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';

window.Swiper = Swiper;
window.SwiperModules = { Navigation, Pagination, FreeMode, Mousewheel };
